import { itemService } from '../../services'

// initial state
const state = () => ({
  items: [],
  item: null,
  template: null
})

// actions
const actions = {
  async getItems({ commit, rootState }, eventId) {
    if (!eventId) {
      eventId = rootState.event?.activeEvent?.id
    }
    await itemService.getItems(eventId).then(
      (items) => {
        commit('getItemsSuccess', items)
      },
      (error) => {
        commit('getItemsFailure', error)
      }
    )
  },
  getItemsTemplate({ commit }, eventId) {
    return itemService.getItemsTemplate(eventId).then(
      (items) => {
        commit('getItemsSuccess', items)
        return JSON.parse(JSON.stringify(items))
      },
      (error) => {
        commit('getItemsFailure', error)
      }
    )
  },
  getItem({ commit }, itemId) {
    itemService.getItem(itemId).then(
      (item) => {
        commit('itemSuccess', item)
      },
      (error) => {
        commit('itemFailure', error)
      }
    )
  },
  async createItem({ commit, dispatch }, itemData) {
    await itemService.createItem(itemData).then(
      (item) => {
        commit('itemSuccess', item)
        dispatch('getItems')
      },
      (error) => {
        commit('itemFailure', error)
      }
    )
  },
  updateItem({ commit, dispatch }, { itemId, itemData }) {
    itemService.updateItem(itemId, itemData).then(
      (item) => {
        commit('itemSuccess', item)
        dispatch('getItems')
      },
      (error) => {
        commit('itemFailure', error)
      }
    )
  },
  deleteItem({ commit, dispatch }, itemId) {
    itemService.deleteItem(itemId).then(
      (item) => {
        commit('itemDelete', item.id)
        dispatch('getItems')
      },
      (error) => {
        commit('itemFailure', error)
      }
    )
  },
  downloadTemplateFile({ commit }, hasType) {
    itemService.downloadTemplate(hasType).then(
      (template) => {
        commit('downloadSuccess', template)
      },
      (error) => {
        commit('downloadFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getItemsSuccess(state, items) {
    state.items = items
  },
  itemSuccess(state, item) {
    state.item = item
  },
  getItemsFailure(state, error) {
    console.log(state, error)
  },
  itemFailure(state, error) {
    console.log(state, error)
  },
  itemDelete(state, itemId) {
    let index = state.items.findIndex((item) => item.id == itemId)
    state.items.splice(index, 1)
  },
  downloadSuccess(state, template) {
    state.template = template
  },
  downloadFailure(state, error) {
    state.template = null
    console.log(error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
